/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { gnoment } from 'shared-ui/gnoment';
import { MODIFICATION_DEADLINE, QUOTA_USAGE_BY_MEMBER_DAILY } from '../constants/rules';
import {
    PERMIT_PRELIMINARY,
    PERMIT_IN_PROGRESS,
    PERMIT_COMPLETE,
    PERMIT_ISSUED,
    LOTTERY_IN_PROGRESS,
    LOTTERY_AWARDED,
    LOTTERY_AWARDED_IN_PROGRESS,
    LOTTERY_WON,
} from '../../src/constants';
import {
    issuanceReadable,
    issuanceStatuses,
    readRuleValue,
    hasRule,
} from '../../src/utils/utilsNew';

// Lottery Issuance (aka Lottery Application)
export const isLotteryIssuance = (issuance) =>
    !!issuance.lottery_id && !issuance.lottery_issuance_id;

// Issuance created from accepting a lottery issuance
export const isIssuanceFromAwardedLottery = (issuance) =>
    !!issuance.lottery_id && !!issuance.lottery_issuance_id;

export function isPermitComplete(reservation) {
    return reservation?.status === issuanceStatuses.get(PERMIT_COMPLETE);
}

export function isIssuedPermit(reservation) {
    return (
        reservation.status === issuanceStatuses.get(PERMIT_ISSUED) ||
        reservation.status === issuanceStatuses.get(PERMIT_COMPLETE) ||
        reservation.status === issuanceStatuses.get(LOTTERY_AWARDED)
    );
}

export function getIssuanceReadableStatus(reservation) {
    return issuanceReadable.get(issuanceStatuses.get(reservation?.status));
}

export function isLotteryIssuanceConvertedFromIssuance(reservation) {
    return (
        reservation.status === issuanceStatuses.get(LOTTERY_AWARDED) ||
        reservation.status === issuanceStatuses.get(LOTTERY_AWARDED_IN_PROGRESS)
    );
}

export function isLotteryApplicationSubmitted(reservation) {
    return reservation.status > issuanceStatuses.get(LOTTERY_IN_PROGRESS);
}

export const isQuotaModifyAllowed = (reservation, permit) => {
    const isAwardedLotteryApplication =
        reservation.status === issuanceStatuses.get(LOTTERY_WON);
    const isAcceptedAwardedReservationInProgress =
        reservation.lottery_awarded &&
        reservation.status === issuanceStatuses.get(PERMIT_IN_PROGRESS);

    // can't modify quota of awarded lottery applications
    if (isAwardedLotteryApplication || isAcceptedAwardedReservationInProgress) {
        return false;
    }

    const hasQuotaByMember = hasRule(
        QUOTA_USAGE_BY_MEMBER_DAILY,
        permit.rules,
        reservation.division_id
    );
    const isPreliminaryOrInProgressReservation = [PERMIT_PRELIMINARY, PERMIT_IN_PROGRESS]
        .map((st) => issuanceStatuses.get(st))
        .includes(reservation.status);
    if (hasQuotaByMember && isPreliminaryOrInProgressReservation) {
        return true;
    }

    let changesAllowed = hasQuotaByMember;

    const modificationDeadline = readRuleValue(MODIFICATION_DEADLINE, permit.rules);
    if (modificationDeadline !== '') {
        const entryDate = gnoment.utc(reservation.start_date);
        const currentDate = gnoment().utc();
        const daysUntilReservation = entryDate.diff(currentDate, 'days');
        if (daysUntilReservation < modificationDeadline) {
            changesAllowed = false;
        }
    }
    return changesAllowed;
};
